import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'paf-result-day-change.scss',
  tag: 'paf-result-day-change',
})

export class PafResultDayChange implements ComponentInterface {

  /**
   * The date string to show as day change text
   */
  @Prop() public headingText!: string;

  /**
   * The heading level to use for the day change
   */
  @Prop() public headingLevel!: number;

  /**
   * Determine if the heading should be visible or not
   */
  @Prop() public visuallyHidden = false;

  public render(): HTMLDivElement {
    const HEADING_TAG = `h${this.headingLevel}`;

    return (
      <HEADING_TAG
        class={{
          hidden: this.visuallyHidden,
          title: true,
        }}
      >{this.headingText}</HEADING_TAG>
    );
  }
}
